import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { useAsyncData } from "@/lib/useAsyncData";
import { ReportLoading } from "@/components/leasing/ReportState";
import SimpleImportWizard from "@/components/SimpleImportWizard";
import Pagination from "@/components/Pagination";
import { Upload, Search } from "lucide-react";

const CARS_CFG = {
  title: "Import mașini & centre de cost (T5)",
  helpAnchor: "tranzactii",
  templatePath: "/fuel/template/cars", templateName: "Sablon_Masini_Centre_Cost.xlsx",
  validatePath: "/fuel/import/cars/validate", confirmPath: "/fuel/import/confirm",
  previewBase: "/fuel/import/preview",
  columns: [["plate_raw", "Nr înmatriculare", "text"], ["angajat", "Nume angajat", "text"],
            ["cost_center", "Centru de cost", "text"]],
  modes: [["replace", "Înlocuiește tot registrul de mașini"], ["add", "Adaugă mașini noi"]],
};

export default function FuelCars() {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [wizard, setWizard] = useState(false);
  const pageSize = 50;

  const { loading, data, reload } = useAsyncData(async () => {
    const res = await api.get("/fuel/cars", { params: { search, page, page_size: pageSize } });
    return res.data;
  }, [search, page]);

  const cars = data?.cars || [];
  const total = data?.total || 0;

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center gap-2 justify-between">
        <div className="relative">
          <Search className="h-4 w-4 absolute left-2.5 top-2.5 text-slate-400" />
          <Input data-testid="fuel-car-search" placeholder="Caută plăcuță, angajat, CC…" value={search} onChange={(e) => { setSearch(e.target.value); setPage(1); }} className="pl-8 w-80" />
        </div>
        <Button data-testid="fuel-import-cars-btn" onClick={() => setWizard(true)} className="bg-slate-900 text-white gap-2"><Upload className="h-4 w-4" /> Import mașini</Button>
      </div>

      {loading && !data ? <ReportLoading label="Se încarcă mașinile…" /> : (
        <>
          <div className="border rounded-md overflow-auto bg-card max-h-[68vh]">
            <table className="w-full text-sm jh-table" data-testid="fuel-car-table">
              <thead className="sticky top-0 bg-slate-100">
                <tr>
                  <th className="text-left px-3 py-2">Nr înmatriculare</th>
                  <th className="text-left px-3 py-2">Nume angajat</th>
                  <th className="text-left px-3 py-2">Centru de cost</th>
                </tr>
              </thead>
              <tbody>
                {cars.map((c) => (
                  <tr key={c.id} className="hover:bg-amber-50/40" data-testid={`fuel-car-row-${c.plate_key}`}>
                    <td className="px-3 py-1.5 font-medium">{c.plate_raw}</td>
                    <td className="px-3 py-1.5">{c.angajat}</td>
                    <td className="px-3 py-1.5">{c.cost_center ? <Badge variant="secondary" className="font-mono">{c.cost_center}</Badge> : <span className="text-slate-400 text-xs">— fără CC —</span>}</td>
                  </tr>
                ))}
                {cars.length === 0 && !loading && (
                  <tr><td colSpan={3} className="px-4 py-10 text-center text-slate-400">Nicio mașină. Importați registrul de mașini.</td></tr>
                )}
              </tbody>
            </table>
          </div>
          <Pagination page={page} pageSize={pageSize} total={total} onPage={setPage} label="mașini" testid="fuel-car-pagination" />
        </>
      )}

      {wizard && <SimpleImportWizard open onOpenChange={(v) => !v && setWizard(false)} onDone={reload} config={CARS_CFG} />}
    </div>
  );
}
